(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casafab-campaign-banner"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cf-campaign')){
customElements.define('cf-campaign',class extends HTMLElement{
 connectedCallback(){
  this.storageKey='cf-campaign-dismissed:'+this.dataset.code+':'+this.dataset.end+':'+this.querySelector('.cf-campaign__message-desktop').textContent.trim();
  if(this.dataset.editor!=='true'){try{if(sessionStorage.getItem(this.storageKey)==='1'){this.hidden=true;return;}}catch(e){}}
  if(this.dataset.pageType==='index'&&this.parentElement.matches('height-observer')){
   this.glassHost=this.parentElement;
   this.glassMotion=window.matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
   this.glassMove=(event)=>{
    if(!this.glassMotion.matches||this.hidden)return;
    this.glassClientX=event.clientX;
    if(this.glassFrame)return;
    this.glassFrame=requestAnimationFrame(()=>{
     this.glassFrame=0;
     const box=this.getBoundingClientRect();
     this.style.setProperty('--cf-glass-x',Math.max(0,Math.min(box.width,this.glassClientX-box.left))+'px');
    });
   };
   this.glassLeave=()=>{cancelAnimationFrame(this.glassFrame);this.glassFrame=0;this.style.removeProperty('--cf-glass-x');};
   this.glassHost.addEventListener('pointermove',this.glassMove,{passive:true});
   this.glassHost.addEventListener('pointerleave',this.glassLeave);
  }
  this.close=()=>{this.hidden=true;clearInterval(this.timer);clearTimeout(this.reset);if(this.dataset.editor!=='true'){try{sessionStorage.setItem(this.storageKey,'1');}catch(e){}}this.parentElement.querySelector('.header button')?.focus({preventScroll:true});};
  this.querySelector('.cf-campaign__close').addEventListener('click',this.close);
  this.tick=()=>{const left=Math.max(0,Number(this.dataset.end)*1000-Date.now());if(!left){this.hidden=true;clearInterval(this.timer);return;}const m=Math.ceil(left/60000),d=Math.floor(m/1440),h=Math.floor(m%1440/60);const s=Math.floor(left/1000),md=Math.floor(s/86400),mh=Math.floor(s%86400/3600),mm=Math.floor(s%3600/60);this.querySelector('[data-clock-mobile]').textContent=(md?md+'j · ':'')+String(mh).padStart(2,'0')+'h '+String(mm).padStart(2,'0')+'m '+String(s%60).padStart(2,'0')+'s';this.querySelector('[data-clock]').textContent=(d?d+' j · ':'')+String(h).padStart(2,'0')+' h · '+String(m%60).padStart(2,'0')+' min';};
  this.tick();this.timer=setInterval(this.tick,1000);
  this.copy=async()=>{const status=this.querySelector('[data-status]');try{await navigator.clipboard.writeText(this.dataset.code);status.textContent=status.dataset.success;this.querySelector('[data-code-label]').textContent=status.dataset.success;clearTimeout(this.reset);this.reset=setTimeout(()=>{this.querySelector('[data-code-label]').textContent=this.dataset.code;status.textContent='';},2200);}catch(e){status.textContent=status.dataset.failure;const range=document.createRange();range.selectNodeContents(this.querySelector('[data-code-label]'));const sel=window.getSelection();sel.removeAllRanges();sel.addRange(range);}};
  this.querySelector('.cf-campaign__code')?.addEventListener('click',this.copy);
 }
 disconnectedCallback(){this.glassHost?.removeEventListener('pointermove',this.glassMove);this.glassHost?.removeEventListener('pointerleave',this.glassLeave);cancelAnimationFrame(this.glassFrame);this.glassFrame=0;this.querySelector('.cf-campaign__close')?.removeEventListener('click',this.close);clearInterval(this.timer);clearTimeout(this.reset);this.querySelector('.cf-campaign__code')?.removeEventListener('click',this.copy);}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casafab-header-search"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cf-header-compact')){
 customElements.define('cf-header-compact',class extends HTMLElement{
  connectedCallback(){
   this.header=this.closest('store-header');
   if(!this.header||!this.header.hasAttribute('sticky'))return;
   this.media=matchMedia('(min-width:1150px)');
   this.mobile=matchMedia('(max-width:699px)');
   this.update=()=>{
    if(this.frame)return;
    this.frame=requestAnimationFrame(()=>{
     this.frame=0;
     const compact=this.header.classList.contains('cf-is-compact');
     const next=this.media.matches&&(compact?window.scrollY>40:window.scrollY>200);
     this.header.classList.toggle('cf-is-compact',next);
     const mobileCompact=this.header.classList.contains('cf-mobile-compact');
     this.header.classList.toggle('cf-mobile-compact',this.mobile.matches&&(mobileCompact?window.scrollY>30:window.scrollY>160));
    });
   };
   window.addEventListener('scroll',this.update,{passive:true});
   this.media.addEventListener('change',this.update);
   this.mobile.addEventListener('change',this.update);
   this.update();
  }
  disconnectedCallback(){
   window.removeEventListener('scroll',this.update);
   this.media?.removeEventListener('change',this.update);
   this.mobile?.removeEventListener('change',this.update);
   cancelAnimationFrame(this.frame);
   this.header?.classList.remove('cf-is-compact','cf-mobile-compact');
  }
 });
}
/* Popup de suggestions : recherche prédictive Shopify rendue par la section cf-search-suggest.
   Le popup est ajouté au <body> en position fixe (la barre a overflow:hidden et le header un backdrop-filter). */
if(!customElements.get('cf-search-suggest')){
 customElements.define('cf-search-suggest',class extends HTMLElement{
  connectedCallback(){
   this.input=document.getElementById(this.dataset.input);
   this.form=this.input&&this.input.form;
   if(!this.form)return;
   this.cache=new Map();
   this.requestId=0;
   this.popup=document.createElement('div');
   this.popup.id=this.dataset.popupId;
   this.popup.className='cf-search-popup';
   this.popup.hidden=true;
   this.popup.setAttribute('role','region');
   this.popup.setAttribute('aria-label',this.dataset.label||'Suggestions');
   document.body.appendChild(this.popup);
   this.onInput=()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>this.search(),220)};
   this.onFocus=()=>{if(!this.keepClosed&&this.input.value.trim().length>=2&&this.popup.childElementCount)this.open()};
   this.onKeydown=(e)=>this.keydown(e);
   this.onFocusOut=(e)=>{const t=e.relatedTarget;if(t&&!this.form.contains(t)&&!this.popup.contains(t))this.close()};
   this.onPointerDown=(e)=>{if(!this.popup.hidden&&!this.form.contains(e.target)&&!this.popup.contains(e.target))this.close()};
   this.onSubmit=()=>this.close();
   this.onViewport=()=>{
    if(this.popup.hidden||this.frame)return;
    this.frame=requestAnimationFrame(()=>{this.frame=0;this.place()});
   };
   this.input.addEventListener('input',this.onInput);
   this.input.addEventListener('focus',this.onFocus);
   this.form.addEventListener('keydown',this.onKeydown);
   this.popup.addEventListener('keydown',this.onKeydown);
   this.form.addEventListener('focusout',this.onFocusOut);
   this.popup.addEventListener('focusout',this.onFocusOut);
   this.form.addEventListener('submit',this.onSubmit);
   document.addEventListener('pointerdown',this.onPointerDown);
   window.addEventListener('scroll',this.onViewport,{passive:true});
   window.addEventListener('resize',this.onViewport);
  }
  disconnectedCallback(){
   if(!this.form)return;
   clearTimeout(this.timer);
   cancelAnimationFrame(this.frame);
   this.controller&&this.controller.abort();
   this.input.removeEventListener('input',this.onInput);
   this.input.removeEventListener('focus',this.onFocus);
   this.form.removeEventListener('keydown',this.onKeydown);
   this.form.removeEventListener('focusout',this.onFocusOut);
   this.form.removeEventListener('submit',this.onSubmit);
   document.removeEventListener('pointerdown',this.onPointerDown);
   window.removeEventListener('scroll',this.onViewport);
   window.removeEventListener('resize',this.onViewport);
   this.popup.remove();
  }
  async search(){
   const q=this.input.value.trim();
   const id=++this.requestId;
   this.controller&&this.controller.abort();
   if(q.length<2){this.close();return}
   let html=this.cache.get(q);
   if(html===undefined){
    if(this.popup.hidden||!this.popup.childElementCount){this.popup.innerHTML='<div class="cf-ss cf-ss--loading"><span class="cf-ss__spinner"></span></div>';this.open()}
    this.popup.classList.add('is-loading');
    this.controller=new AbortController();
    const params=new URLSearchParams({
     q:q,
     section_id:'cf-search-suggest',
     'resources[type]':'product,query,collection',
     'resources[limit]':this.dataset.limit||'8',
     'resources[limit_scope]':'each',
     'resources[options][unavailable_products]':'last',
     'resources[options][fields]':'title,product_type,variants.title,vendor,tag'
    });
    try{
     const response=await fetch(this.dataset.url+'?'+params.toString(),{signal:this.controller.signal});
     const doc=new DOMParser().parseFromString(await response.text(),'text/html');
     const results=doc.querySelector('[data-cf-ss-results]');
     html=results?results.outerHTML:'';
     this.cache.set(q,html);
    }catch(e){
     if(id!==this.requestId)return;
     html='';
    }
   }
   if(id!==this.requestId)return;
   this.popup.classList.remove('is-loading');
   if(!html){this.close();return}
   this.popup.innerHTML=html;
   this.open();
  }
  open(){
   this.popup.hidden=false;
   this.input.setAttribute('aria-expanded','true');
   this.place();
  }
  close(){
   if(this.popup.hidden)return;
   this.popup.hidden=true;
   this.input.setAttribute('aria-expanded','false');
  }
  place(){
   const r=this.form.getBoundingClientRect();
   if(!r.width||r.bottom<=0){this.close();return}
   const top=Math.round(r.bottom+10);
   this.popup.style.top=top+'px';
   this.popup.style.maxHeight=Math.max(200,window.innerHeight-top)+'px';
  }
  keydown(e){
   if(e.key==='Escape'&&!this.popup.hidden){
    e.preventDefault();
    this.close();
    this.keepClosed=true;
    this.input.focus();
    this.keepClosed=false;
    return;
   }
   if(e.key!=='ArrowDown'&&e.key!=='ArrowUp')return;
   if(this.popup.hidden)return;
   const links=[...this.popup.querySelectorAll('a[href]')];
   if(!links.length)return;
   e.preventDefault();
   const index=links.indexOf(document.activeElement);
   if(index===-1){if(e.key==='ArrowDown')links[0].focus();return}
   const next=index+(e.key==='ArrowDown'?1:-1);
   if(next<0)this.input.focus();
   else links[Math.min(next,links.length-1)].focus();
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casafab-mattress-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-mattress-offer')) {
class CfMattressOffer extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.data = JSON.parse(this.querySelector('[data-offer-json]').textContent);
    this.bed = this.data.bed;
    this.selected = null;
    this.formId = this.closest('product-rerender')?.getAttribute('observe-form');
    this.money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR',{style:'currency',currency:this.dataset.currency||'EUR'});
    this.querySelectorAll('[data-model]').forEach(button => button.addEventListener('click', () => {this.selected=Number(button.dataset.model);this.update();},{signal:this.abort.signal}));
    document.addEventListener('variant:change', e => {
      if (e.detail?.formId === this.formId) {this.bed=e.detail.variant;this.update();}
    },{signal:this.abort.signal});
    this.querySelector('[data-add]').addEventListener('click',(event)=>{event.preventDefault();event.stopPropagation();this.add();},{signal:this.abort.signal});
    this.update();
  }
  disconnectedCallback(){this.abort?.abort();}
  dimension(title) {const m=String(title||'').match(/(\d{2,3})\s*[x×X]\s*(\d{2,3})/);return m ? m[1]+'x'+m[2] : null;}
  update() {
    const form=this.formId && document.getElementById(this.formId);
    const currentId=form?.querySelector('[name="id"]')?.value;
    if(currentId){this.bed=this.data.variants.find(v=>String(v.id)===String(currentId)) || this.bed;}
    const size=this.dimension(this.bed?.title);
    this.matches=this.data.models.map(m=>(m.variants||[]).find(v=>size && this.dimension(v.title)===size));
    this.hidden = !this.matches.some(Boolean);
    if (this.selected===null || !this.matches[this.selected]?.available) this.selected=this.matches.findIndex(v=>v?.available);
    this.querySelector('[data-size]').textContent=size?'Taille des matelas : '+size.replace('x',' × ')+' cm':'Choisissez d’abord la taille du lit';
    this.querySelectorAll('[data-model]').forEach(button=>{
      const i=Number(button.dataset.model),v=this.matches[i];
      button.hidden=!v;
      if (!v)return;
      button.disabled=!v.available || Boolean(this.busy);
      button.setAttribute('aria-pressed',String(i===this.selected));
      button.querySelector('[data-original]').textContent=this.money.format(v.price/100);
      button.querySelector('[data-price]').textContent=this.money.format(Math.round(v.price*.9)/100);
      button.querySelector('[data-card-size]').textContent=this.dimension(v.title).replace('x',' × ')+' cm';
      const status=button.querySelector('[data-availability]');
      const inStock=v.available && v.tracked && v.quantity>0;
      status.dataset.stock=inStock?'yes':'no';
      status.textContent=inStock?'● En stock':(v.arrival || (v.available?'Délai à confirmer':'Indisponible · délai à confirmer'));
    });
    const chosen=this.matches[this.selected];
    this.querySelector('[data-summary]').hidden=!chosen;
    if(chosen){
      const reduced=Math.round(chosen.price*.9);
      this.querySelector('[data-choice]').textContent='1 lit + 1 '+['DENALI','MEMORIS','EVEREST'][this.selected]+' · '+size.replace('x',' × ')+' cm';
      this.querySelector('[data-total]').textContent=this.money.format((this.bed.price+reduced)/100);
      this.querySelector('[data-saving]').textContent=this.money.format((chosen.price-reduced)/100)+' de remise sur votre matelas';
    }
    this.querySelector('[data-empty]').hidden=this.matches.some(Boolean);
    this.querySelector('[data-add]').disabled=this.busy || !this.bed?.available || !this.matches[this.selected]?.available;
    this.querySelector('[data-add]').textContent=this.busy?'Ajout en cours…':!this.bed?.available?'Lit indisponible dans cette variante':'Ajouter le lit + le matelas';
  }
  async add(){
    this.update();
    if(this.busy || !this.bed?.available || !this.matches[this.selected]?.available)return;
    const items=[{id:this.bed.id,quantity:1},{id:this.matches[this.selected].id,quantity:1}];
    this.busy=true;this.setAttribute('aria-busy','true');this.update();this.querySelector('[data-error]').textContent='';
    const root=(window.Shopify?.routes?.root||this.dataset.root||'/').replace(/\/?$/,'/');
    try {
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result=await response.json().catch(()=>({}));
      if(!response.ok || result.status>=400)throw new Error(result.description||'Ces articles ne peuvent pas être ajoutés. Vérifiez leur disponibilité.');
      window.location.assign(root+'cart');
    } catch(error){this.querySelector('[data-error]').textContent=error.message||'Ajout impossible. Réessayez.';this.busy=false;this.removeAttribute('aria-busy');this.update();}
  }
}
customElements.define('cf-mattress-offer',CfMattressOffer);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casafab-menu-promo"] && !Shopify.designMode) return;
  try {
    const casaMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const casaObserver = new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => {
      if(isIntersecting && !document.hidden && !casaMotion.matches) target.play().catch(() => {});
      else target.pause();
    });
  }, {threshold:0.15});
  function casaObserve(){document.querySelectorAll('.casa-menu-video').forEach(video => casaObserver.observe(video));}
  casaObserve();
  document.addEventListener('shopify:section:load',casaObserve);
  document.addEventListener('cfmm:filled',casaObserve);
  document.addEventListener('visibilitychange',() => {document.querySelectorAll('.casa-menu-video').forEach(video => {if(document.hidden) video.pause();else {casaObserver.unobserve(video);casaObserver.observe(video);}});});
  casaMotion.addEventListener('change',() => {document.querySelectorAll('.casa-menu-video').forEach(video => {casaObserver.unobserve(video);casaObserver.observe(video);});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-v2"] && !Shopify.designMode) return;
  try {
    /* Vidéos des cartes : lecture quand la vidéo est visible, pause sinon (aucune lecture si mouvements réduits) */
  (() => {
    if (window.cfObserveCardVideos) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && !reduceMotion.matches) {
          const playing = video.play();
          if (playing && playing.catch) playing.catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '150px 0px', threshold: 0.01 }) : null;

    window.cfObserveCardVideos = (root) => {
      (root || document).querySelectorAll('[data-cf-card-video] video:not([data-cf-observed])').forEach((video) => {
        video.setAttribute('data-cf-observed', '');
        video.muted = true;
        if (observer) observer.observe(video);
      });
    };

    const init = () => window.cfObserveCardVideos(document);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
